import Vue from "vue";
import VueRouter from "vue-router";
import websiteLayout from "@/layouts/website/websiteLayout.vue";


// Vue-router—报错：NavigationDuplicated: Avoided redundant navigation to current location 的问题
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject);
    return routerPush.call(this, location).catch((error) => error);
};

Vue.use(VueRouter);

const routes = [
    {
        path: "/", redirect: "/homes",
    },
    {
        path: "/homes",
        name: "homes",
        component: websiteLayout,
        redirect: "/homes/home",
        children: [
            {
                path: "home",
                name: "home",
                meta: {
                    title: "首页"
                },
                component: ()=>import("@/views/homes/HomeView.vue"),
            },
            {
                path: "register",
                name: "register",
                meta: {
                    title: "注册"
                },
                component:()=>import("@/views/homes/RegisterViews.vue")
            },
            {
                path: "reset-password",
                name: "reset-password",
                meta: {
                    title: "忘记密码"
                },
                component:()=>import("@/views/homes/ResetPasswordViews.vue")
            },
            {
                path: "authentication",
                name: "authentication",
                meta: {
                    title: "课程认证"
                },
                component:()=>import("@/views/homes/Authentication.vue")
            },
            {
                path: "authentication-process",
                name: "authentication-process",
                meta: {
                    title: "课程认证"
                },
                component:()=>import("@/views/homes/AuthenticationProcess.vue")
            },
        ],
    }, // 介绍相关的路由
    {
        path: "/college-introductions",
        name: "college-introductions",
        component: websiteLayout,
        redirect: "/college-introductions/college-introduction",
        children: [{
            path: "college-introduction",
            name: "college-introduction",
            component: () => import("@/views/college-introduction/CollegeIntroductionView.vue"),
        },],
    }, // 课程相关的路由
    {
        path: "/curriculums",
        name: "curriculums",
        component: websiteLayout,
        redirect: "/curriculums/curriculum",
        children: [{
            path: "curriculum", name: "curriculum", component: () => import("@/views/curriculums/CurriculumsViews.vue"),
        },{
            path: "course-detail", name: "course-detail", component: () => import("@/views/curriculums/CourseDetailViews.vue"),
        },{
            path: "broadcast", name: "broadcast", component: () => import("@/views/curriculums/BroadcastViews.vue"),
        }],
    },

    // 关于我们的相关路由
    {
        path: "/abouts", name: "abouts", component: websiteLayout, redirect: "/abouts/notice", children: [{
            path: "notice", name: "notice", meta: {
                title: "公告事项"
            }, component: () => import("@/views/abouts/NoticeViews.vue"),
        }, {
            path: "common-problem", name: "common-problem", meta: {
                title: "常见问题"
            }, component: () => import("@/views/abouts/CommonProblemViews.vue"),
        }, {
            path: "answering-question", name: "answering-question", meta: {
                title: "答疑解惑"
            }, component: () => import("@/views/abouts/AnsweringQuestionViews.vue"),
        },{
            path: "notice-detail", name: "notice-detail", meta: {
                title: "公告事项"
            }, component: () => import("@/views/abouts/NoticeDetailViews.vue"),
        },{
            path: "all-answerViews", name: "all-answerViews", meta: {
                title: "全部回答"
            }, component: () => import("@/views/abouts/AllAnswerViews.vue"),
        },],
    }, // 个人中心的相关路由
    {
        path: "/personal-center",
        name: "personal-center",
        component: websiteLayout,
        redirect: "/personal-center/resume",
        children: [{
            path: "resume", name: "resume", meta: {
                title: "我的简历"
            }, component: () => import("@/views/personal-center/ResumeViews.vue"),
        }, {
            path: "course-application", name: "course-application", meta: {
                title: "听课申请现况"
            }, component: () => import("@/views/personal-center/CourseApplicationViews.vue"),
        },

            {
                path: "my-studies", name: "my-studies", meta: {
                    title: "我的学习现况"
                }, component: () => import("@/views/personal-center/MyStudiesViews.vue"),
            },

            {
                path: "my-question", name: "my-question", meta: {
                    title: "我的提问"
                }, component: () => import("@/views/personal-center/MyQuestionViews.vue"),
            },

            {
                path: "certificate-issuance", name: "certificate-issuance", meta: {
                    title: "证书颁发"
                }, component: () => import("@/views/personal-center/CertificateIssuanceViews.vue"),
            },

            {
                path: "personal-info", name: "personal-info", meta: {
                    title: "个人信息管理"
                }, component: () => import("@/views/personal-center/PersonalInfoViews.vue"),
            },

            {
                path: "points-detailsViews", name: "points-detailsViews", meta: {
                    title: "积分明细"
                }, component: () => import("@/views/personal-center/PointsDetailsViews.vue"),
            },

        ],
    },

    {
        path: "/login", name: "login", component: () => import("@/views/LoginView.vue"),
    }, {
        path: "/notFound", name: "notFound", component: () => import("@/views/NotFound.vue"),
    },

    {
        path: "*", redirect: "/notFound",
    },];

const router = new VueRouter({
    routes,
});

export default router;
